export const GET_SETTINGS_BY_ID_API = "GET_SETTINGS_BY_ID_API";
export const START_ASSESSMENT = "START_ASSESSMENT";
